export default __webpack_public_path__ + "static/media/monkey8.623d028e.JPG";